import React,{Component} from 'react';
import {PostData} from '../service/postData';

//----Include Fragment Pages-----
import HeaderSection from '../websiteFolder/web_fragment/header';
import FooterPage from '../websiteFolder/web_fragment/footer';
//----End Include Fragment Pages-----

export default class featuresPagePanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : false,
            isLoggedin : false,
            blogArray : []
        }
    }

    async componentDidMount(){
        this.setState({isLoaded:true});
    }

    render(){
        
        return(
            <div id="page-wrapper">
                <React.Fragment>
                    <div id="main" className="mainSectionWebsite">
                        <section className="header">
                            <div className="container">
                                <HeaderSection />
                                {/* <!-- Banner --> */}
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h1 className="txt-style-6">Vyavsay Features</h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        <section className="sec5">
                            <div className="container">
                                <div className="row rowE">
                                    <div className="col-lg-4">
                                        <div className="icon">
                                        <span>
                                            <i className="far fa-file-alt"></i>
                                        </span>
                                        </div>
                                        <div className="content">
                                        <h4>Send Estimates & Quotations</h4>
                                        <p>
                                            With <strong>Vyavsay</strong>, creating and sharing professional estimates or quotations takes just a few clicks.
                                        </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                        <span>
                                            <i className="fas fa-weight"></i>
                                        </span>
                                        </div>
                                        <div className="content">
                                        <h4>Track Orders</h4>
                                        <p>
                                            Stay in control of your business with real-time order tracking. Vyavsay helps you monitor the entire order journey, from confirmation to delivery—no missed updates, no confusion.
                                        </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                        <span>
                                            <i className="far fa-list-alt"></i>
                                        </span>
                                        </div>
                                        <div className="content">
                                        <h4>Choose Themes</h4>
                                        <p>
                                            Your documents, your style. Vyavsay lets you pick from a range of sleek invoice and quotation themes, so your business always looks polished and professional.
                                        </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                        <span>
                                            <i className="fas fa-wallet"></i>
                                        </span>
                                        </div>
                                        <div className="content">
                                        <h4>Record Expences</h4>
                                        <p>
                                            Easily log daily business expenses and categorize them with Vyavsay. Keep an eye on spending, reduce financial leaks, and simplify your tax preparation.
                                        </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                        <span>
                                            <i className="fas fa-sync"></i>
                                        </span>
                                        </div>
                                        <div className="content">
                                        <h4>Recievables & Payble</h4>
                                        <p>
                                            Know what’s coming in and what’s going out. Vyavsay helps you track all customer dues and vendor payments in one place—making cash flow management easy.
                                        </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                        <span>
                                            <i className="fas fa-truck-moving"></i>
                                        </span>
                                        </div>
                                        <div className="content">
                                        <h4>Delivery Challan</h4>
                                        <p>
                                            Generate and print delivery challans instantly. Vyavsay ensures accurate records of goods dispatched, helping you maintain clear logistics and avoid disputes.
                                        </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>

                                <div className="row rowE">
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="far fa-file-alt"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Bank Accounts</h4>
                                            <p>
                                                Link and manage all your business bank accounts within Vyavsay. Track payments, reconcile transactions, and view balances—without switching platforms.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="fas fa-weight"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Track Cash Flow</h4>
                                            <p>
                                                Get a real-time view of your cash flow and stay financially fit. Vyavsay gives you a clear picture of your income and expenses so you can plan better and grow faster.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="far fa-list-alt"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Cheques</h4>
                                            <p>
                                                Manage issued and received cheques effortlessly. Vyavsay keeps records of due dates, clearances, and bank deposits, ensuring nothing falls through the cracks.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="fas fa-wallet"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Tax Invoicing / Billing</h4>
                                            <p>
                                                Create tax-compliant invoices quickly and accurately with Vyavsay. From local GST to global tax formats, Vyavsay adapts to your business needs.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="fas fa-sync"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Business Status</h4>
                                            <p>
                                                Check your business health at a glance. With Vyavsay’s dashboard, monitor key metrics like sales, payments, expenses, and inventory—on one screen.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="fas fa-truck-moving"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Business Reports</h4>
                                            <p>
                                                Generate detailed reports—sales, tax, profit & loss, and more. Vyavsay gives you clear insights to make informed decisions without waiting for an accountant.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>

                                <div className="row rowE">
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="far fa-file-alt"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Data Safety and Security</h4>
                                            <p>
                                                Your business data is safe with Vyavsay. With cloud backups and secure encryption, your information is protected 24/7—so you can work worry-free.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="fas fa-weight"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Regular/Thermal Printer</h4>
                                            <p>
                                                Whether you're using a regular printer or a thermal one, Vyavsay supports both. Print receipts, invoices, or challans with ease and flexibility.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="far fa-list-alt"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Online / Offline billing software</h4>
                                            <p>
                                                No internet? No problem. Vyavsay works both online and offline, so you can continue billing even during network downtime—your business never stops.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="icon">
                                            <span><i className="fas fa-wallet"></i></span>
                                        </div>
                                        <div className="content">
                                            <h4>Lifetime Fee</h4>
                                            <p>
                                                Say goodbye to monthly payments. Vyavsay offers a one-time lifetime fee—giving you full access to powerful features without recurring charges.
                                            </p>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </section>


                        {/* Footer Code Here */}
                        <FooterPage />
                    </div>
                </React.Fragment>                
            </div>
        )
    }
}